import { render, staticRenderFns } from "./DinersClubIcon.vue?vue&type=template&id=4d65d672&"
import script from "./DinersClubIcon.vue?vue&type=script&lang=js&"
export * from "./DinersClubIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports